module.exports = __webpack_public_path__ + "static/media/William McKinley - 1896.0ee3c2bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/William McKinley - 1896.jpg
// module id = 574
// module chunks = 0